import React from "react";
import { twMerge } from "tailwind-merge";

type CardProps = {
    children: React.ReactNode;
    className?: string;
    onClick?: () => void;
    noPadding?: boolean;
};

export const Card = ({ children, className, onClick, noPadding = false }: CardProps) => {
    return (
        <div
            onClick={onClick}
            className={twMerge(
                "bg-white rounded-xl shadow-sm border border-gray-200 transition-all",
                !noPadding && "p-6",
                onClick && "cursor-pointer hover:shadow-md hover:border-indigo-200",
                className
            )}
        >
            {children}
        </div>
    );
};
